import React from 'react';
import Modal from '../Modal';
import { Product } from 'ai-api/types/purchase';
import { formatPrice } from '../../Utils/formatting';

interface PurchaseConfirmModalProps {
    isOpen: boolean;
    onClose: () => void;
    product: Product | null;
    selectedDate: Date | null;
    selectedTime: Date | null;
    onConfirm: () => void;
}

const PurchaseConfirmModal: React.FC<PurchaseConfirmModalProps> = ({
    isOpen,
    onClose,
    product,
    selectedDate,
    selectedTime,
    onConfirm
}) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <div className="purchase-confirm">
                <h2>{`Konfirmasi Pembelian Anda`}</h2>
                <p>{`Anda akan membeli:`}</p>
                <p className="purchase-item">{product?.name || 'Loading...'}</p>
                {selectedDate && selectedTime && (
                    <p className="session-time">
                        {`Waktu Sesi: ${selectedDate.toLocaleDateString()} jam ${selectedTime.getHours()}:00`}
                    </p>
                )}
                <p className="purchase-price">{`Total: ${formatPrice(product?.finalAmount || 0, "IDR")}`}</p>

                <div className="payment-methods">
                    <h3>{`Pembayaran melalui`}</h3>
                    <div className="stripe-logo-container">
                        <div className="stripe-logo">
                            <span className="stripe-text">Stripe</span>
                        </div>
                    </div>
                    <p className="stripe-description">
                        {`Anda dapat membayar dengan kartu kredit/debit melalui prosesor pembayaran aman Stripe`}
                    </p>
                </div>

                <div className="purchase-actions">
                    <button className="cancel-button" onClick={onClose}>{`Batal`}</button>
                    <button className="confirm-button" onClick={onConfirm}>{`Konfirmasi Pembelian`}</button>
                </div>
            </div>
        </Modal>
    );
};

export default PurchaseConfirmModal;